import { combineReducers } from "redux";
import {
  GET_A_MENTOR_FORM,
  VIEW_STARTUP_APPLICATION_DATA,
  GET_SESSION_DATA,
  GET_SUMMARY_DATA,
} from "../../common/constants/actionConstants";

// const getMentorFormList = (state = [], action) => {
//   switch (action.type) {
//     case GET_A_MENTOR_FORM:
//       return { ...action.payload };

//     default:
//       return state;
//   }
// };

const getViewApplicationData = (state = [], action) => {
  switch (action.type) {
    case VIEW_STARTUP_APPLICATION_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};

const getSummaryData = (state = [], action) => {
  switch (action.type) {
    case GET_SUMMARY_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};

const getSessionData = (state = [], action) => {
  switch (action.type) {
    case GET_SESSION_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const GetMentorFormReducer = combineReducers({
  // getMentorFormList,
  getViewApplicationData,
  getSummaryData,
  getSessionData,
});

export default GetMentorFormReducer;
